import axiosInstance from "../../axios/axiosInstance";
import { ACTIVE_PROMO_CODES_COUNT, ACTIVE_PROMO_CODES_LISTING, APPROVE_PROMO, CREATE_PROMO_CODES, CREATE_UPDATE_OFFER_PROMOCODES, DELETE_PROMO_CODE, EDIT_PROMO_CODES, GET_COMPLETE_OFFER_PROMOCODES, GET_OFFER_PROMOCODE_BY_ID, IN_ACTIVE_PROMO_CODES_COUNT, IN_ACTIVE_PROMO_CODES_LISTING, OFFER_LISTING, PROMO_CODES_LISTING, STATUS_UPDATE_PROMO_CODE, UPDATE_OFFER_PROMOCODE_STATUS } from "../../constants";

export const createPromoCodes = (props) => onResponse => {
    console.log(props,);

    try {
        axiosInstance.post(CREATE_PROMO_CODES, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const createUpdateOfferPromocodes = (props) => onResponse => {
    console.log(props,);

    try {
        axiosInstance.post(CREATE_UPDATE_OFFER_PROMOCODES, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getOfferPromocodeById = (props) => onResponse => {

    try {
        axiosInstance.post(GET_OFFER_PROMOCODE_BY_ID, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const updateOfferPromoCodeStatus = (id, updateData) => (onResponse) => {
    try {
        axiosInstance
            .post(UPDATE_OFFER_PROMOCODE_STATUS, { id, ...updateData })
            .then((response) => onResponse(response))
            .catch((err) => onResponse(err.response));
    } catch (error) {
        console.error(error);
    }
};



export const editPromoCodes = (props) => onResponse => {

    try {
        axiosInstance.post(EDIT_PROMO_CODES, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getOfferListing = () => onResponse => {
    try {
        axiosInstance.get(OFFER_LISTING)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getPromocodesListing = (props) => onResponse => {
    try {
        let BASE_URL = PROMO_CODES_LISTING
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getCompleteOfferPromocodes = (props) => onResponse => {
    try {
        let BASE_URL = GET_COMPLETE_OFFER_PROMOCODES
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getActivePromocodesListing = (props) => onResponse => {
    try {
        let BASE_URL = ACTIVE_PROMO_CODES_LISTING
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                console.log(response, "************")
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getInActivePromocodesListing = (props) => onResponse => {
    try {
        let BASE_URL = IN_ACTIVE_PROMO_CODES_LISTING
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getActivePromocodesCount = (props) => onResponse => {
    try {
        let BASE_URL = ACTIVE_PROMO_CODES_COUNT
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getInActivePromocodesCount = (props) => onResponse => {
    try {
        let BASE_URL = IN_ACTIVE_PROMO_CODES_COUNT
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const deletePromoCode = (id) => onResponse => {
    console.log("//////");
    try {
        axiosInstance.delete(DELETE_PROMO_CODE, { data: { offerId: id } })
            .then((response) => {
                console.log(response, "*//*/*/*/");
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const statusPromoCodeUpdate = (id) => onResponse => {

    try {
        axiosInstance.post(APPROVE_PROMO, { offerIds: id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const statusPromoUpdate = (id) => (onResponse) => {
    try {
        axiosInstance
            .post(STATUS_UPDATE_PROMO_CODE, { offerId: id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};

export const approvePromocode = (id) => onResponse => {
    try {
        axiosInstance.post(APPROVE_PROMO, { offerIds: id })
            .then((response) => {
                onResponse(response)
            })
            .catch((err) => {
                onResponse(err.response)
            })
    } catch (error) {

    }
}